/*
  Cajón lateral del carrito de Binco (03/11/2026).

  El tema no lo dibuja porque el ajuste `cart_type` no llega desde el repo (queda en "página"), así
  que este script arma uno propio, sin depender de archivos del tema base:
    - se abre al tocar el carrito de la barra de navegación y al agregar un producto;
    - se dibuja a partir de /cart.js y se actualiza con /cart/change.js;
    - muestra envío gratis, ahorro (precio tachado), subtotal, FINALIZAR PEDIDO y medios de pago.
  En la página /cart no interviene (ahí funciona binco-cart.js).
*/
(() => {
  if (/^\/cart\/?$/.test(location.pathname)) return;

  const PAY = window.BINCO_PAYBAND || '';
  const cache = new Map();
  let root;
  let lastFocus;
  let cart = null;

  const fmt = (cents) => {
    const n = Math.round(cents / 100);
    return `$ ${String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  };
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const loadProduct = (handle) => {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      );
    }
    return cache.get(handle);
  };

  const img = (url) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=200` : '');

  const truck =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h14v10H1z"/><path d="M15 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  const trash =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M6 6l1 14h10l1-14"/><path d="M10 10v6M14 10v6"/></svg>';
  const bag =
    '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';

  const build = () => {
    root = document.createElement('div');
    root.className = 'binco-drawer';
    root.hidden = true;
    root.innerHTML =
      '<div class="binco-drawer__veil" data-close></div>' +
      '<aside class="binco-drawer__panel" role="dialog" aria-modal="true" aria-label="Tu carrito">' +
      '<header class="binco-drawer__head"><h2>Tu carrito</h2>' +
      '<button type="button" class="binco-drawer__close" data-close aria-label="Cerrar carrito">&#10005;</button></header>' +
      '<div class="binco-drawer__body" data-body></div>' +
      '</aside>';
    document.body.appendChild(root);

    root.addEventListener('click', onClick);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  };

  const render = async () => {
    const body = root.querySelector('[data-body]');
    if (!cart || !cart.item_count) {
      body.innerHTML =
        `<div class="binco-drawer__empty">${bag}<p>Tu carrito está vacío</p>` +
        '<a class="binco-drawer__cta" href="/collections/all">SEGUIR COMPRANDO</a></div>';
      return;
    }

    let savings = 0;
    let rows = '';
    for (const it of cart.items) {
      const product = await loadProduct(it.handle);
      const variant = product && product.variants ? product.variants.find((v) => v.id === it.variant_id) : null;
      const was = variant && variant.compare_at_price > it.final_price ? variant.compare_at_price : 0;
      if (was) savings += (was - it.final_price) * it.quantity;
      const vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      rows +=
        `<li class="binco-drawer__item" data-key="${esc(it.key)}">` +
        `<a class="binco-drawer__thumb" href="${esc(it.url)}">${
          it.image ? `<img src="${esc(img(it.image))}" alt="${esc(it.product_title)}" loading="lazy">` : ''
        }</a>` +
        '<div class="binco-drawer__info">' +
        `<a class="binco-drawer__name" href="${esc(it.url)}">${esc(it.product_title)}</a>` +
        (vt ? `<span class="binco-drawer__tag">${esc(vt)}</span>` : '') +
        `<div class="binco-drawer__price"><strong>${fmt(it.final_line_price)}</strong>` +
        (was ? `<s>${fmt(was * it.quantity)}</s>` : '') +
        '</div>' +
        '<div class="binco-drawer__qty">' +
        `<button type="button" data-qty="${it.quantity - 1}" aria-label="Menos">&minus;</button>` +
        `<span>${it.quantity}</span>` +
        `<button type="button" data-qty="${it.quantity + 1}" aria-label="Más">+</button>` +
        '</div></div>' +
        `<button type="button" class="binco-drawer__remove" data-qty="0" aria-label="Quitar">${trash}</button>` +
        '</li>';
    }

    body.innerHTML =
      '<div class="binco-drawer__scroll">' +
      '<div class="binco-cart-ship"><p class="binco-cart-ship__text">¡Obtuviste el Envío Gratis! 🎉</p>' +
      `<div class="binco-cart-ship__bar"><span class="binco-cart-ship__fill"></span><span class="binco-cart-ship__truck">${truck}</span></div></div>` +
      `<ul class="binco-drawer__list">${rows}</ul></div>` +
      '<footer class="binco-drawer__foot">' +
      (savings > 0 ? `<div class="binco-cart-save"><span>Ahorrás</span><span>-${fmt(savings)}</span></div>` : '') +
      `<div class="binco-drawer__total"><span>Subtotal</span><span>${fmt(cart.total_price)}</span></div>` +
      '<a class="binco-drawer__cta" href="/checkout">FINALIZAR PEDIDO</a>' +
      (PAY ? `<img class="binco-cart-pay" src="${esc(PAY)}" alt="Medios de pago" loading="lazy">` : '') +
      '</footer>';
  };

  const refresh = async () => {
    try {
      cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    } catch (e) {
      cart = null;
    }
    await render();
  };

  const open = async () => {
    if (!root) build();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('binco-drawer-open');
    requestAnimationFrame(() => root.classList.add('is-open'));
    await refresh();
    const c = root.querySelector('.binco-drawer__close');
    if (c) c.focus();
  };

  const close = () => {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('binco-drawer-open');
    setTimeout(() => {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const setQty = async (key, qty) => {
    const row = root.querySelector(`[data-key="${CSS.escape(key)}"]`);
    if (row) row.classList.add('is-busy');
    try {
      cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then((r) => r.json());
    } catch (e) {
      /* se vuelve a leer el carrito abajo */
    }
    await refresh();
    syncBubble();
  };

  // Actualiza el contador del carrito de la barra de arriba
  const syncBubble = () => {
    if (!cart) return;
    document.querySelectorAll('cart-icon cart-bubble, .cart-bubble').forEach((b) => {
      const n = b.querySelector('.cart-bubble__text-count') || b.querySelector('[class*="count"]');
      if (n) n.textContent = cart.item_count;
      b.classList.toggle('visually-hidden', !cart.item_count);
    });
  };

  const onClick = (e) => {
    if (e.target.closest('[data-close]')) return close();
    const q = e.target.closest('[data-qty]');
    if (q) {
      const li = q.closest('[data-key]');
      if (li) setQty(li.dataset.key, Number(q.dataset.qty));
    }
  };

  // Tocar el carrito de la barra abre el cajón en vez de ir a /cart
  document.addEventListener(
    'click',
    (e) => {
      const t = e.target.closest && e.target.closest('a[href$="/cart"], a[href="/cart"], button[aria-controls="cart-drawer"], .binco-nav__action');
      if (!t) return;
      const isCart = t.matches('button[aria-controls="cart-drawer"]') || /\/cart\/?$/.test(t.getAttribute('href') || '') || (t.matches('.binco-nav__action') && t.querySelector('cart-icon'));
      if (!isCart || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    },
    true
  );

  // Al agregar un producto, se abre el cajón
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const p = nativeFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then((r) => {
          if (r && r.ok) setTimeout(open, 150);
        }).catch(() => {});
      }
    } catch (e) {
      /* nada */
    }
    return p;
  };

  window.bincoCartDrawer = { open, close };
})();
